@if (erroredFields.length > 0) {
  <div>
    <div style="font-weight: bold; padding: 10px">
      The following fields have errors
    </div>
    <ul class="form-errors">
      @for (field of erroredFields; track field) {
        <li>
          <a (click)="focusElementClicked.emit(field)">
            {{
            field._fields[0].templateOptions.label !== '' &&
            field._fields[0].templateOptions.label
            ? field._fields[0].templateOptions.label
            : field._fields[0].templateOptions.title
            }}
          </a>
          @for (item of field.errors | keyvalue; track item) {
            <span>
              {{ formatErrorKey(item.key) }}
            </span>
          }
        </li>
      }
    </ul>
  </div>
}
